import { render, staticRenderFns } from "./DetailContentTextEdit.vue?vue&type=template&id=720d8f96&"
import script from "./DetailContentTextEdit.vue?vue&type=script&lang=js&"
export * from "./DetailContentTextEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports